export namespace IResponsiveComponentLayoutConfig {
  /**
   * Return an instance of IResponsiveComponentLayoutConfig with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IResponsiveComponentLayoutConfig>
  ): IResponsiveComponentLayoutConfig =>
    ({
      ...(partial ?? {}),
    }) as IResponsiveComponentLayoutConfig;
}

/**
 * Responsive layout info at component level for one screen size
 */
export interface IResponsiveComponentLayoutConfig {
  /**
   * Width of the component as % of total row width, values between 0 and 100
   */
  component_width: number | undefined;
  /**
   * Specifies the referenced component index in the components list,
   * which is found in the parent proto that contains the Layout object.
   * The index is 0-based.
   * The referenced component should be rendered based on [componentWidth]
   */
  component_index: number | undefined;
}
